export default "/images/vendor/@coreui/icons/svg/flag/cif-si.svg?62f1c869374b79af6fbaf49f719c29e0";